import React from 'react';

// Helper function to remove <style> tags and inline CSS
const sanitizeEmailContent = (html) => {
    // Remove <style> tags and their content
    const cleanedHtml = html.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '');
    // Remove any leftover CSS comments
    const noComments = cleanedHtml.replace(/<!--[\s\S]*?-->/g, '');
    return noComments;
};

const EmailContent = ({ content }) => {
    const sanitizedContent = sanitizeEmailContent(content);

    return (
        <div className="email-cleaned-content" dangerouslySetInnerHTML={{ __html: sanitizedContent }}></div>
    );
};

export default EmailContent;
